<template>
  <div class="message">
    <van-list v-model="loading" v-if="list.length > 0 && !isNone" :finished="finished" @load="onLoad" class="cons-list">
      <div class="items" v-for="(item, index) in list" :key="index" @click="handleClickItems(item)">
        <div class="img-block">
          <div class="solit" v-if="item.isRead !== 1"></div>
          <img src="../../assets/images/person/me_message@2x.png" class='img-msg' alt="">
        </div>
        <div class="items-con">
          <div class="cons-txt1" v-html="item.content"></div>
          <!-- <div class="cons-txt2">2023-07-27 19:00 OCE智逾未来] AIFV OCE 中心互联即将开始!</div> -->
          <div class="cons-txt3">
            <div class="txt3-left">
              {{ item && item.times }}
            </div>
          </div>
        </div>
      </div>
    </van-list>
    <div class="search-none" v-else-if="list.length <= 0 && isNone">
      <img src="@/assets/images/home/empty_state_none@2x.png" class="none-img" alt="">
      <div class="none-txt">暂无内容</div>
    </div>
    <returnBack></returnBack>
  </div>
</template>
<script>
import { iepXxbCaseMessages, updateIepXxbCaseMessagesIsRead } from '@/api/api'
import returnBack from './components/returnBack.vue'
import withRouteTracking from '@/utils/withRouteTracking'
const UserProfile = {
  components: {
    returnBack
  },
  data () {
    return {
      list: [],
      loading: false,
      finished: false,
      pageNum: 1,
      pageSize: 10,
      isNone: false
    }
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    }
  },
  mounted () {
    this.onLoad()
  },
  methods: {

    onLoad () {
      let params = {
        openId: this.userInfo.iepOpenId,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      iepXxbCaseMessages(params).then(res => {
        if (res.data.list.length < this.pageSize) {
          this.finished = true
        }
        res.data.list.map(item => {
          item.times = this.$moment(item.createTime * 1).format('YYYY-MM-DD HH:mm')
        })
        this.list = this.list.concat(res.data.list)
        // 加载状态结束
        this.loading = false
        if (this.list.length <= 0) {
          this.isNone = true
        } else {
          this.isNone = false
        }
        this.pageNum++
      })
    },

    async handleClickItems (item) {
      await updateIepXxbCaseMessagesIsRead(item.id)
      this.$set(item, 'isRead', 1)
    }
  }
}
export default withRouteTracking(UserProfile)
</script>
<style lang="less" scoped>
.message {
  padding-top: 30px;
  box-sizing: border-box;

  .items {
    display: flex;
    margin-bottom: 24px;
    padding: 0 20px;
    box-sizing: border-box;

    .img-block {
      position: relative;
      min-width: 42px;
      margin-right: 10px;
      height: 42px;

      .solit {
        width: 6px;
        height: 6px;
        position: absolute;
        top: 3px;
        right: 3px;
        border-radius: 50%;
        background-color: #FF0000;
      }

      .img-msg {
        min-width: 42px;
        height: 42px;
        display: block;
      }
    }

    .items-con {
      flex: 1;

      .cons-txt1 {
        font-size: 15px;
        line-height: 24px;
        color: #000000;
        margin-bottom: 3px;
        display: flex;
        flex-direction: column;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }

      .cons-txt2 {
        line-height: 20px;
        color: #929292;
        font-size: 12px;
        display: -webkit-box;
        -webkit-line-clamp: 2; //显示3行文字
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-bottom: 3px;
      }

      .cons-txt3 {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 20px;

        .txt3-left {
          font-size: 12px;
          color: #929292;
        }

        .txt3-right {
          display: flex;
          align-items: center;
          font-size: 12px;
          color: #929292;

          .icon-arrow {
            width: 10px;
            height: 10px;
            display: block;
            margin-left: 6px;
          }
        }
      }
    }
  }

  .search-none {
    .none-img {
      width: 185px;
      margin-left: 50%;
      transform: translateX(-50%);
      margin-top: 50px;
    }

    .none-txt {
      font-size: 12px;
      color: #949BA5;
      text-align: center;
      margin-top: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/person/message.vue